import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[form-field-host]',
})
export class FormFieldDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
